import Vue from "vue"
import Router from "vue-router"
import Feeds from "./views/Feeds.vue"
import Groups from "./views/Groups.vue"
import TMRs from "./views/TMRs.vue"
import Wagons from "./views/Wagons.vue"
import inventory from "./views/inventory.vue"
import Dashboard from "./views/Dashboard.vue"
import ReportWagons from "./views/ReportWagons.vue"
import ReportDelivery from "./views/ReportDelivery.vue"
import ReportMaterials from "./views/ReportMaterials.vue"
import ReportTransaction from "./views/ReportTransactions.vue"
import Settings from "./views/Settings.vue"
import Equipments from "./views/Equipments.vue"
import WagonPlanPrint from "./views/WagonPlanPrint.vue"
import RecipePrint from "./components/RecipePrint.vue"
import Login from "./views/Login.vue"
import signup from "./views/Signup.vue"
import Recipe from "./views/Recipe.vue"
import store from "./store";
import license from "./views/License.vue"


Vue.use(Router)

async function redirectIfNotAuth (to, from, next) {
  const user = await store.getters.getUser;
  if (!user) {
    next({ name: "login" })
  } else {
    next()
  }
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: async (to, from, next) => {
        const user = await store.getters.getUser;
        if (user)
          next({name: "dashboard"})
        else
          next()
      }
    },
    {
      path: "/signup",
      name: "signup",
      component: signup
    },
    {
      path: "/license",
      name: "license",
      component: license
    },
    {
      path: "/",
      name: "home",
      component: Dashboard,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/feeds",
      name: "feeds",
      component: Feeds,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/groups",
      name: "groups",
      component: Groups,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
    path: "/tmrs",
    name: "tmrs",
    component: TMRs,
    beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/wagons",
      name: "wagons",
      component: Wagons,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/recipe",
      name: "recipe",
      component: Recipe,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/inventory",
      name: "inventory",
      component: inventory,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/equipments",
      name: "equipments",
      component: Equipments,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/wagon-plan-print",
      name: "WagonPlanPrint",
      component: WagonPlanPrint,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/recipe-print:id",
      name: "RecipePrint",
      component: RecipePrint,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/report-wagons",
      name: "report-wagons",
      component: ReportWagons,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/report-delivery",
      name: "report-delivery",
      component: ReportDelivery,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/report-materials",
      name: "report-materials",
      component: ReportMaterials,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },
    {
      path: "/report-transactions",
      name: "report-transactions",
      component: ReportTransaction,
      beforeEnter: (to, from, next) => redirectIfNotAuth(to, from, next)
    },

  ],
})
